import { render, staticRenderFns } from "./TabTableRziMonitoring.vue?vue&type=template&id=3d64ca3d&scoped=true&"
import script from "./TabTableRziMonitoring.vue?vue&type=script&lang=js&"
export * from "./TabTableRziMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./TabTableRziMonitoring.vue?vue&type=style&index=0&id=3d64ca3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64ca3d",
  null
  
)

export default component.exports